import { store } from "@/src/store";

/**
 * Resolves `office_url` for qarshisu.net document create payloads.
 * Only from explicit value or Admission Office task/applicant context — no other fallbacks.
 */
export const resolveOfficeUrlForDocCreate = (explicit?: string | null): string | null => {
  const fromExplicit = String(explicit ?? "").trim();
  if (fromExplicit) return fromExplicit;

  const fromContext = String(store.getState().admissionOfficeDoc.officeUrl ?? "").trim();
  if (fromContext) return fromContext;

  return null;
};

/**
 * Adds `office_url` only when it came from the task/applicant.
 * Otherwise the field is omitted from the payload.
 */
export const withOfficeUrlForDocCreate = <T extends object>(data: T): T | (T & { office_url: string }) => {
  const record = data as T & { office_url?: string | null };
  const officeUrl = resolveOfficeUrlForDocCreate(record.office_url);
  if (officeUrl == null) return data;
  return { ...data, office_url: officeUrl };
};
